<div class="pagination-wrapper">
    <a class="page-wrapper" *ngFor="let page of pages" [routerLink]="page.route || '/'">
        <div class="page"></div>
    </a>
    <div class="current-page" [ngStyle]="{ 'top.px': page * 18 }"></div>
</div>
